import { shallowRef, ref, computed } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { setValueByPath, setValueByPathToVue } from '../../../utils/index'
import { get } from '../../../utils/index'
import { useRoute, useRouter } from 'vue-router/composables'
import { useSetStorageComponent } from './use-set-storage-component'

import { CRITERIFORMCOLUM } from './use-common-param'
/**
 * 查询表单处理
 * @param {查询条件是否设置默认事件（如光标在输入框时点击回车触发查询等）} queryFormEvent
 * @returns
 */
export function useCriteriaQuery(url, code, parametersStorageSuffix) {
  const { getTemplateData, compileData } = useTemplate()
  const queryForm = shallowRef({ items: [] })
  const queryData = ref({})

  const queryTabs = computed(() =>
    queryForm.value?.items?.filter((im) => im.component?.code === 'search-tab')
  )

  const route = useRoute()
  const router = useRouter()

  const { getParametersBySessionStorage } = useSetStorageComponent(parametersStorageSuffix)

  //当key存在时修改queryData对应key的值为data，key不存在时修改queryData为data
  const updateQueryData = (data) => {
    if (!queryForm.value?.items || queryForm.value?.items?.length <= 0) return
    if (Object.keys(data).length <= 0) {
      queryData.value = data
      return false
    }
    queryForm.value.items.forEach((element) => {
      if (
        (element.visible || element.component?.code === 'search-tab') &&
        data[element.property] !== undefined
      ) {
        setValueByPathToVue(queryData.value, element.property, data[element.property])
      }
    })
  }

  //设置默认值
  const setDefaultQuery = (data) => {
    const templateData = getTemplateData()
    if (!queryForm.value) return false
    queryData.value = queryForm.value.items.reduce((pre, cur) => {
      if (cur.defaultValue) {
        setValueByPath(pre, cur.property, compileData(cur.defaultValue, templateData))
      }
      return pre
    }, {})
    queryData.value = Object.assign({}, queryData.value, data)
  }

  // 设置高级查询条件
  const setQueryForm = (resData) => {
    queryForm.value = {
      code: resData.criteria.code,
      id: resData.criteria.id,
      criteria: {
        customize: resData.criteria.customize,
        function: resData.criteria.function,
        system: resData.criteria.system,
      },
      form: {
        property: {
          formGroup: false,
          colNum: CRITERIFORMCOLUM,
          showMessage: false,
          ...resData.criteria?.property,
        },
      },
      items: resData.items,
    }
  }

  //高级查询组件的ref
  const criteriaRef = ref(null)
  const initParameter = async () => {
    const { defaultQueryId, defaultQueryParameters } = route.query ?? {}
    if (defaultQueryId) {
      router.replace({ name: route.name })
      return criteriaRef.value?.getCriteriaItem(defaultQueryId)
    } else if (defaultQueryParameters) {
      router.replace({ name: route.name })
      return defaultQueryParameters
    } else {
      return getParametersBySessionStorage()
    }
  }

  const getCriteria = async () => {
    const [res] = await get(`${url}${code ?? ''}`)
    if (res) {
      const defaultParameter = await initParameter()
      return [res.data, defaultParameter]
    } else {
      return Promise.reject({ msg: `【${url}${code}】请求错误` })
    }
  }

  return {
    getCriteria,
    queryForm,
    queryTabs,
    queryData,
    updateQueryData,
    setQueryForm,
    setDefaultQuery,
    criteriaRef,
  }
}
